export interface Toast {
    id: string,
    title: string,
    content: string,
    type: ToastType
}

export enum ToastType {
    Info = 1,
    Success = 2,
    Warning = 3,
    Error = 4
}
